
const orgion = [
  {
    name:'冲榜',
    CateId:1,
    playTypeOpt:[],
  },
  {
    name:'队伍PK类',
    CateId:2,
    playTypeOpt:[],
  },
  {
    name:'充值类',
    CateId:3,
    playTypeOpt:[],
  },
  {
    name:'游戏类',
    CateId:4,
    playTypeOpt:[],
  },
  {
    name:'抽奖类',
    CateId:5,
    playTypeOpt:[],
  },
]
/***
 任务类型：
 1-送礼个人梯度奖；
 2-送礼个人榜单-总榜；
 3-收礼个人榜单-总榜；4-房间榜单-总榜；
 5-个人充值梯度 6-收礼个人梯度奖 7.道具升级（送礼）
 8.CP送礼榜单 9.奖池瓜分 10.充值排行榜
 11.个人送礼排行-日榜 12.个人送礼梯度-队伍 13.送礼排行-队伍 14.家族送礼排行
 17.游戏充值和下注梯度 18.家族收礼排行 19.家族收礼排行-成员收礼排行 27-个人收礼排行-日榜
 28-房间收礼排行-日榜；30.队伍报名奖励 31.人气投票排行 32.人气抽奖

 表单类型：
 1-冲榜-榜单类；2-冲榜-梯度类
 **/
const playTypeTemp = [
  {
    taskType:1,
    text:'送礼个人梯度奖',
    titleList:[],
    taskFormId:2,
  },
  {
    taskType:2,
    text:'送礼个人榜单-总榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:3,
    text:'收礼个人榜单-总榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:4,
    text:'房间榜单-总榜',
    titleList:[],
    taskFormId:1,
  },
    {
    taskType:5,
    text:'个人充值梯度',
    titleList:[],
      taskFormId:2,
  },
    {
    taskType:6,
    text:'收礼个人梯度奖',
    titleList:[],
      taskFormId:2,
  },
  {
    taskType:11,
    text:'个人送礼排行-日榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:27,
    text:'个人收礼排行-日榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:28,
    text:'房间收礼排行-日榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:8,
    text:'CP榜单-总榜',
    titleList:[],
    taskFormId:1,
  },
  {
    taskType:29,
    text:'送礼cp梯度奖',
    titleList:[],
    taskFormId:2,
  },
]
export default {
  state:{
    TEMPLATE_CLASS_OPTS:orgion,
    PLAY_TYPE_TEMP:playTypeTemp,
  },
  getters:{
    getTemplateClassOpts: state => state.TEMPLATE_CLASS_OPTS,
    getPlayTypeTemp: state => state.PLAY_TYPE_TEMP,
  },
  mutations:{
    setTemplateClassOpts(state,data){
      // console.log(data)
      state.TEMPLATE_CLASS_OPTS = orgion
      // 模板分类 data.CateId === TEMPLATE_CLASS_OPTS[i].CateId TEMPLATE_CLASS_OPTS[i].playTypeOpt = data[e]
      // 建立TEMPLATE_CLASS_OPTS的映射，提高查找效率
      const templateMap = new Map();
      state.TEMPLATE_CLASS_OPTS.forEach((template, index) => {
        templateMap.set(template.CateId, {
          index,
          taskNameSet: new Set(template.playTypeOpt.map(n => n.TaskName))
        });
      });

      // 遍历data对象
      Object.keys(data).forEach(e => {
        const item = data[e];
        item.forEach(m => {
          const templateInfo = templateMap.get(m.CateId);
          if (templateInfo) {
            // 使用Set提高查重效率
            if (!templateInfo.taskNameSet.has(m.TaskName)) {
              templateInfo.taskNameSet.add(m.TaskName);
              state.TEMPLATE_CLASS_OPTS[templateInfo.index].playTypeOpt.push(m);
            }
          }
        });
      });

    }
  },
  actions:{

  }
}



// WEBPACK FOOTER //
// ./src/store/module/tempAct.js